import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "admin-dashboard" }
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = { class: "dashboard-link dropdown" }
const _hoisted_4 = { class: "dropdown-content" }
const _hoisted_5 = { class: "main-content-admin" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("h3", null, "Admin Menu", -1)),
      _createVNode(_component_router_link, {
        to: "/admin",
        class: "dashboard-link"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Dashboard")
        ])),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/admin/product-list",
        class: "dashboard-link"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("Product List")
        ])),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/admin/user-list",
        class: "dashboard-link"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Customer List")
        ])),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("span", null, "Invoice List", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/admin/invoice-list/paid",
            class: "dropdown-item"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Paid")
            ])),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/admin/invoice-list/unpaid",
            class: "dropdown-item"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("UnPaid")
            ])),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/admin/invoice-list/proforma",
            class: "dropdown-item"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Proforma")
            ])),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_router_link, {
        to: "/admin/update-company-info",
        class: "dashboard-link"
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("Company Info")
        ])),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/admin/about-me",
        class: "dashboard-link"
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("About Me")
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_view)
    ])
  ]))
}